import { authFetch } from "./authFetch";
import { BACKEND_URL } from "lib/utils/baseUrl";
import { normalizeApiMessage } from "lib/i18n/apiMessage";

export async function createAdminUser({
  email,
  user_name,
  password,
  role,
  country_code,
}) {
  try {
    const path = `${BACKEND_URL}/admin/role/create_user`;

    const res = await authFetch(path, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ email, user_name, password, role, country_code }),
    });

    const result = await res.json().catch(() => null);

    if (!result) {
      return {
        success: false,
        status: res.status,
        ...normalizeApiMessage(
          { message: "Failed to parse server response." },
          "Failed to parse server response.",
        ),
        messageKey: "api.common.serverError",
      };
    }

    if (!res.ok || result?.success !== true) {
      return {
        success: false,
        status: res.status,
        code: result?.code ?? "",
        data: result?.data ?? null,
        ...normalizeApiMessage(result, "Failed to create user."),
      };
    }

    return {
      success: true,
      status: res.status,
      code: result?.code ?? "",
      ...normalizeApiMessage(result, "User created successfully."),
      data: result?.data ?? null,
    };
  } catch (err) {
    return {
      success: false,
      ...normalizeApiMessage(
        { message: err?.message || "Network error" },
        err?.message || "Network error",
      ),
      messageKey: "api.common.networkError",
    };
  }
}
